import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { MarketLeftNavsList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Download_market_fire_fighting_video = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/Banner/portal-banner7.jpg" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {MarketLeftNavsList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Download Market Fire-Fighting Video")}
                    </h3>
                  </div>
                  <div className="dig-login2">
                    <div className="map2">
                      <a className="fontSizeClass" href={"assets/img/VTS_03_1.mp4"} target="_blank">
                        <i className="bi bi-download" target="_blank" style={{ marginRight: "10px" }}/>
                        {t( "Loading of a Fire Brigade Tanker Through on KMC's Deep Tube-Well for Fire-Fighting Purpose")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Download_market_fire_fighting_video;
